export const DELIVERY_STATUS_MAP = {
  STARTED: 'started',
  FAILED: 'failed',
  STOPPED: 'stopped',
  PROVISIONING: 'provisioning',
  STARTING: 'starting',
  STOPPING: 'stopping',
  DRAFT: 'draft',
} as const;
